import {
  GET_HOMEWORK_SOLUTION_QUERIES,
  GET_HOMEWORK_SOLUTION_QUERIES_ERROR,
  GET_HOMEWORK_SOLUTION_QUERIES_SUCCESS,
  GetHomeworkSolutionQueriesAction,
  GetHomeworkSolutionQueriesErrorAction,
  GetHomeworkSolutionQueriesSuccessAction,
  UPDATE_HOMEWORK_SOLUTION_QUERIES,
  UPDATE_HOMEWORK_SOLUTION_QUERIES_ERROR,
  UPDATE_HOMEWORK_SOLUTION_QUERIES_SUCCESS,
  UpdateHomeworkSolutionQueriesAction,
  UpdateHomeworkSolutionQueriesErrorAction,
  UpdateHomeworkSolutionQueriesSuccessAction,
} from "./actionTypes";

import { HomeworkSolutionQueryDto } from "../../interfaces";

//#region Get Homework Solution Queries

export const getHomeworkSolutionQueries =
  (): GetHomeworkSolutionQueriesAction => {
    return {
      type: GET_HOMEWORK_SOLUTION_QUERIES,
      payload: {},
    };
  };

export const getHomeworkSolutionQueriesSuccess = (
  response: HomeworkSolutionQueryDto
): GetHomeworkSolutionQueriesSuccessAction => {
  return {
    type: GET_HOMEWORK_SOLUTION_QUERIES_SUCCESS,
    payload: response,
  };
};

export const getHomeworkSolutionQueriesError = (
  error: any
): GetHomeworkSolutionQueriesErrorAction => {
  return {
    type: GET_HOMEWORK_SOLUTION_QUERIES_ERROR,
    payload: error,
  };
};
//#endregion

//#region Update Homework Solution Queries

export const updateHomeworkSolutionQueries = (
  request: HomeworkSolutionQueryDto
): UpdateHomeworkSolutionQueriesAction => {
  return {
    type: UPDATE_HOMEWORK_SOLUTION_QUERIES,
    payload: { request },
  };
};

export const updateHomeworkSolutionQueriesSuccess = (
  response: HomeworkSolutionQueryDto
): UpdateHomeworkSolutionQueriesSuccessAction => {
  return {
    type: UPDATE_HOMEWORK_SOLUTION_QUERIES_SUCCESS,
    payload: response,
  };
};

export const updateHomeworkSolutionQueriesError = (
  error: any
): UpdateHomeworkSolutionQueriesErrorAction => {
  return {
    type: UPDATE_HOMEWORK_SOLUTION_QUERIES_ERROR,
    payload: error,
  };
};
//#endregion
